export default "__VITE_ASSET__89320038__"